export default __webpack_public_path__ + "5ee2d172ee5263a9bc87ac6002a85f1b.png";